module.exports = __webpack_public_path__ + "static/img/maskcount_orange.61afca8e.png";